module.exports = __webpack_public_path__ + "img/2023big28.baf5e5f8.png";